import { render, staticRenderFns } from "./StepDots.vue?vue&type=template&id=e023a2fc&scoped=true&"
import script from "./StepDots.vue?vue&type=script&lang=js&"
export * from "./StepDots.vue?vue&type=script&lang=js&"
import style0 from "./StepDots.vue?vue&type=style&index=0&id=e023a2fc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e023a2fc",
  null
  
)

export default component.exports